<template>
  <div class="scendetail">
    <vannav></vannav>
    <div class="detailtop">
      <span>
        <span class="title header"> {{ list.branchName }} </span>
      </span>
    </div>
    <div class="detail">
      <div>
        <div>
          <span> 编号: </span>
          <span>
            {{ list.branchCode }}
          </span>
        </div>
        <div>
          <span> 名称: </span>
          <span>
            {{ list.areaName }}
          </span>
        </div>
      </div>
      <div>
        <div>
          <span>最大功率（W）</span>
          <span>{{ list.lineP === -1 ? "-W" : list.lineP + "W" }}</span>
        </div>
        <div>
          <span>最大电流（A）</span>
          <span>{{ list.maxLineA === -1 ? "-A" : list.maxLineA + "A" }}</span>
        </div>
        <div>
          <span>最大电压（V）</span>
          <span>{{ list.maxLineV === -1 ? "-V" : list.maxLineV + "V" }}</span>
        </div>
        <div>
          <span>最小电压（V）</span>
          <span>{{ list.minLineV === -1 ? "-V" : list.minLineV + "V" }}</span>
        </div>
      </div>
    </div>
    <div class="detailtop">
      <span>
        <span class="title">实时数据 </span>
      </span>
      <span class="van_span">
        当前状态：
        <van-tag :type="list.eleOnoff === 1 ? 'success' : 'danger'">{{
          list.eleOnoff === 1 ? "开启" : "关闭"
        }}</van-tag>
      </span>
    </div>
    <div class="detail1">
      <div>
        <div>
          <img :src="require('../assets/scendetail/V.png')" alt="" />
          <span>当前电压（V）</span>
        </div>
        <div>
          <span>
            <i ref="V_BarChart" class="_V"></i>
          </span>
          <span class="V">{{
            list1.lineV === -1 ? "-V" : list1.lineV + ""
          }}</span>
        </div>
      </div>
      <div>
        <div>
          <img :src="require('../assets/scendetail/A.png')" alt="" />
          <span>当前电流（A）</span>
        </div>
        <div>
          <span>
            <i ref="A_BarChart" class="_A"></i>
          </span>
          <span class="A">{{
            list1.lineA === -1 ? "-A" : list1.lineA + ""
          }}</span>
        </div>
      </div>
      <div>
        <div>
          <img :src="require('../assets/scendetail/P.png')" alt="" />
          <span>当前功率（P）</span>
        </div>
        <div>
          <span>
            <i ref="P_BarChart" class="_P"></i>
          </span>
          <span class="P">{{
            list1.lineP === -1 ? "-P" : list1.lineP + ""
          }}</span>
        </div>
      </div>
      <div>
        <div>
          <img :src="require('../assets/scendetail/C.png')" alt="" />
          <span>当前温度（℃）</span>
        </div>
        <div>
          <span>
            <i ref="C_BarChart" class="_C"></i>
          </span>
          <span class="C">{{
            list1.eleTemp === -1 ? "-" : list1.eleTemp
          }}</span>
        </div>
      </div>
    </div>

    <div class="detailtop">
      <span>
        <span class="title">微断控制 </span>
      </span>
      <span class="van_span">
        <van-button plain size="mini" type="primary" @click="changeZj"
          >漏电自检</van-button
        ></span
      >
    </div>
    <div class="fieldTime">
      <van-field
        :value="currentStartTime"
        class="vanField"
        clickable
        label="开始时间"
        name="datetimePicker"
        readonly
        @click="showPickerStart = true"
      />
      <van-field
        :value="currentEndTime"
        class="vanField"
        clickable
        label="结束时间"
        name="datetimePicker"
        readonly
        @click="showPickerEnd = true"
      />
    </div>
    <div class="stepValue">
      <span>最大功率</span>
      <van-stepper
        v-model="stepValue"
        :max="25000"
        :min="1000"
        button-size="22"
        disable-input
        input-width="50px"
        step="1000"
        theme="round"
      />
    </div>
    <div class="van_button">
      <van-button
        color="rgba(70, 122, 255, 1)"
        plain
        type="default"
        @click="cancel"
        >重 置</van-button
      >

      <van-button color="rgba(70, 122, 255, 1)" type="primary" @click="onSubmit"
        >保 存</van-button
      >
    </div>
    <van-popup v-model="showPickerStart" position="bottom">
      <van-datetime-picker
        type="time"
        @cancel="showPickerStart = false"
        @confirm="onConfirmStart"
      />
    </van-popup>
    <van-popup v-model="showPickerEnd" position="bottom">
      <van-datetime-picker
        type="time"
        @cancel="showPickerEnd = false"
        @confirm="onConfirmEnd"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  branchInfo,
  branchRealTimeData,
  pubMsgBreakZj,
  sendScheduleBreakStrategy,
} from "@/api/scenario.js";
import { checkData } from "@/util/index";
import { Dialog, Toast } from "vant";

export default {
  data() {
    return {
      list: {
        lineP: -1,
        maxLineA: -1,
        maxLineP: -1,
        maxLineV: -1,
        minLineV: -1,
      },
      list1: {
        lineV: "0.00",
        eleTemp: "0.00",
        lineA: "0.00",
        lineP: "0.00",
      },
      currentStartTime: null,
      currentEndTime: null,
      showPickerStart: false,
      showPickerEnd: false,
      stepValue: 20000,
    };
  },
  mounted() {
    this.getbranchInfo();
  },
  destroyed() {
    this.list = {};
  },
  methods: {
    cancel() {
      this.currentStartTime = null;
      this.stepValue = 20000;
      this.currentEndTime = null;
    },
    onSubmit() {
      if (this.currentStartTime == null && this.currentEndTime == null) {
        Toast("请输入有效时间");
        return;
      }
      let { collectorSerial, branchCode, substr } = this.list;
      let a = this.currentStartTime.split(":");
      let b = this.currentEndTime.split(":");
      let openTime = a[0] + a[1];
      let closeTime = b[0] + b[1];
      sendScheduleBreakStrategy(
        collectorSerial,
        branchCode,
        substr,
        this.$route.query.branchId,
        this.stepValue,
        openTime,
        closeTime
      ).then((res) => {
        if (res.data.data == "下发成功") {
          Toast("下发成功");
        }
      });
    },
    changeZj() {
      Dialog.confirm({
        title: "提示",
        message: "是否需要设备自检",
      })
        .then(() => {
          let { collectorSerial, branchCode, substr } = this.list;
          console.log(collectorSerial, branchCode, substr);

          pubMsgBreakZj(
            collectorSerial,
            branchCode,
            160,
            substr,
            this.$route.query.branchId
          ).then((res) => {
            if (
              res.data.code == 200 &&
              res.data.data.result == "success" &&
              res.data.data.break_zj == "160"
            ) {
              Toast("自检成功");
            }
          });
        })
        .catch(() => {});
    },
    onConfirmStart(time) {
      this.currentStartTime = time;
      this.showPickerStart = false;
    },
    onConfirmEnd(time) {
      this.currentEndTime = time;
      this.showPickerEnd = false;
    },
    getbranchInfo() {
      branchInfo(this.$token, this.$route.query.branchId).then((res) => {
        if (res.data.code === 200) {
          if (checkData(res.data.data)) {
            this.list = res.data.data;
          }
          this.$set(this.list);
        }
      });
      branchRealTimeData(this.$token, this.$route.query.branchId)
        .then((res) => {
          if (res.data.code === 200 && checkData(res.data.data)) {
            this.list1 = res.data.data;
            Object.keys(this.list1).map((item) => {
              this.list1[item] = Number(this.list1[item]).toFixed(2);
            });
            /*
             * 对柱状渲染
             * */
            console.log(this.list1);
            this.drawBarChart(this.list1);
          }
        })
        .catch(() => {});
    },

    drawBarChart(list) {
      let maxV = 300;
      let maxA = 400;
      let maxP = 25000;
      let maxC = 100;

      this.$refs.V_BarChart.style.width =
        (list.lineV / maxV) * 100 > 100
          ? "100%"
          : (list.lineV / maxV) * 100 + "%";
      this.$refs.A_BarChart.style.width =
        (list.lineA / maxA) * 100 > 100
          ? "100%"
          : (list.lineA / maxA) * 100 + "%";
      this.$refs.P_BarChart.style.width =
        (list.lineP / maxP) * 100 > 100
          ? "100%"
          : (list.lineP / maxP) * 100 + "%";
      this.$refs.C_BarChart.style.width =
        (list.eleTemp / maxC) * 100 > 100
          ? "100%"
          : (list.eleTemp / maxC) * 100 + "%";
    },
  },
};
</script>

<style lang="less" scoped>
.scendetail {
  padding-bottom: 100px;
  box-sizing: border-box;
}

.detail1 {
  margin: auto;
  margin-top: 5px;
  padding: 0 0.3rem;
}

.detail {
  margin: 0 auto;
  padding: 0 0.3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 4.5rem;

  & > div {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: inherit;
    width: 100%;
    flex-wrap: wrap;

    &:first-child {
      height: 1.2rem;
      width: 100%;

      & > div {
        width: 35%;
        text-align: left;

        & > span {
          &:first-child {
            font-size: 0.3rem;
            color: #cccccc;
            position: relative;

            &:before {
              position: absolute;
              content: "";
              width: 0.16rem;
              height: 0.16rem;
              background-color: #1a5cd7;
              border-radius: 0.08rem;
              left: -40%;
              top: 30%;
            }
          }

          &:last-child {
            font-size: 0.35rem;
            color: rgba(72, 74, 77, 0.84);
          }
        }
      }
    }

    &:nth-child(2) {
      border-radius: 0.2rem;
      background-color: #ebebff;
      flex: 1;
      box-shadow: 0 0 10px 1px #e3e3e3;

      & > div {
        width: 40%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-evenly;
        line-height: 25px;

        & > span:first-child {
          font-size: 12px;
          color: rgba(35, 39, 38, 0.6);
        }
      }
    }
  }
}

.detail1 {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  & > div {
    width: inherit;
    height: 80px;
    //background-color: #c3e9f3;
    display: flex;
    flex-direction: inherit;
    justify-content: space-evenly;

    margin-bottom: 5px;

    & > div {
      text-align: left;

      &:first-child {
        & > span {
          color: #7a7a7a;
        }

        & > img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }

      &:last-child {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        & > span:first-child {
          position: relative;
          width: 75%;
          height: 10px;
          background-color: #fff;
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
          box-shadow: inset 0 0 2px 1px #cccccc;

          & > i {
            transition: 1s ease-in-out;
            position: absolute;
            left: 0;
            top: 0;
            width: 0;
            height: 10px;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;

            &._V {
              background: linear-gradient(
                to right,
                rgba(64, 190, 248, 1),
                rgba(149, 233, 255, 1)
              );
              box-shadow: 0 0 5px 0 rgba(149, 233, 255, 1);
            }

            &._A {
              background: linear-gradient(
                to right,
                rgba(85, 128, 253, 1),
                rgba(154, 180, 255, 1)
              );
              box-shadow: 0 0 5px 0 rgba(154, 180, 255, 1);
            }

            &._P {
              background: linear-gradient(
                to right,
                rgba(133, 93, 255, 1),
                rgba(193, 172, 255, 1)
              );
              box-shadow: 0 0 5px 0 rgba(193, 172, 255, 1);
            }

            &._C {
              background: linear-gradient(
                to right,
                rgba(255, 113, 93, 1),
                rgba(255, 173, 161, 1)
              );
              box-shadow: 0 0 5px 0 rgba(255, 173, 161, 1);
            }
          }
        }

        & > span:last-child {
          position: absolute;
          right: 1%;
          font-size: 18px;
          font-weight: bolder;

          &.V {
            color: rgba(64, 190, 248, 1);
          }

          &.A {
            color: rgba(85, 128, 253, 1);
          }

          &.P {
            color: rgba(133, 93, 255, 1);
          }

          &.C {
            color: rgba(255, 113, 93, 1);
          }
        }
      }
    }
  }
}

.detailtop {
  height: 50px;
  text-align: start;
  margin: auto;
  border-bottom: 1px solid rgb(247, 247, 247);
  box-shadow: 1px 1px 1px rgb(211, 211, 211);
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > span:first-child {
    font-style: normal;
    font-weight: bolder;
  }

  .title {
    font-size: 16px;
    vertical-align: middle;
    position: relative;
    margin-left: 24px;

    &.header:before {
      position: absolute;
      content: "";
      left: -60%;

      top: 2%;
      border-radius: 5px;
      width: 4px;
      height: 16px;
      background-color: #1a5cd7;
    }

    &:before {
      position: absolute;
      content: "";
      left: -20%;

      top: 2%;
      border-radius: 5px;
      width: 4px;
      height: 16px;
      background-color: #1a5cd7;
    }
  }

  & i {
    font-size: 25px;
    padding: 10px;
    vertical-align: middle;
  }

  & > .van_span {
    vertical-align: middle;
    margin-right: 20px;
  }
}

.active {
}

.fieldTime {
  margin-top: 2px;
  width: 100%;
  display: flex;
  padding: 0 10px;
  box-sizing: border-box;
  justify-content: center;

  .vanField {
    width: 48%;
  }
}

.van-cell--borderless::after,
.van-cell:last-child::after {
  display: block;
}

.stepValue {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 89%;
  height: 1.2rem;
  padding-left: 12px;
  box-sizing: border-box;
  border-bottom: 1.2px solid rgb(235, 235, 235);
  margin: auto;
}

.van_button {
  margin: 15px 0;
  display: flex;
  justify-content: space-around;

  .van-button {
    flex: 1;
    margin: 0 10px;
    border-radius: 5px;
    letter-spacing: 4px;
  }
}
</style>
